
import { mapGetters, mapMutations } from 'vuex'
import * as ov from '@/constants/constants'

export default {
    props: [
        'id',
        'text',
        'files',
        'is_new',
        'narrator',
        'client',
        'soundengineer',
        'formatted_created_at',
        'reply_text',
        'reply_files',
        'order_id',
        'is_new_in_new_order',
        'is_exist_in_new_order',
        'service',
        'orderstatuses_id',
        'prevstatus',
        'is_reply_for',
        'author_name',
        'author_image',
        'from',
        'to',
        'reason',
    ],

    computed: {
        ...mapGetters(['isAuthenticated', 'loggedInUser', 'storeOrder', 'appInfo']),

        ov() {
            return ov
        },

        iamNarrator() {
            return (this.loggedInUser.role == 'narrator')
        },

        iamClient() {
            return (this.loggedInUser.role == 'client')
        },

        iamSoundengineer() {
            return (this.loggedInUser.role == 'soundengineer')
        },

        authorName() {
            if (typeof this.id === 'undefined' || this.isMine) return this.loggedInUser.firstname + ' ' + this.loggedInUser.lastname
            return this.author_name
        },

        myName() {
            return this.loggedInUser.firstname + ' ' + this.loggedInUser.lastname
        },

        narratorName() {
            return this.narrator.firstname + ' ' + this.narrator.lastname
        },

        clientName() {
            return this.client.firstname + ' ' + this.client.lastname
        },

        soundengineerName() {
            return this.soundengineer.firstname + ' ' + this.soundengineer.lastname
        },

        authorImage() {
            var image
            if (typeof this.id === 'undefined' || this.isMine) image = this.loggedInUser.image
            image = this.author_image
            if (!image) image = ov.DEFAULT_IMAGE
            return image
        },

        myImage() {
            return this.loggedInUser.image ? this.loggedInUser.image : ov.DEFAULT_IMAGE
        },

        narratorImage() {
            return this.narrator.image ? this.narrator.image : ov.DEFAULT_IMAGE
        },

        clientImage() {
            return this.client.image ? this.client.image : ov.DEFAULT_IMAGE
        },

        soundengineerImage() {
            return this.soundengineer && this.soundengineer.image ? this.soundengineer.image : ov.DEFAULT_IMAGE
        },

        isMine() {
            return (this.from == this.loggedInUser.id)
        },

        isFromBuhgalter() {
            return (this.from == ov.USER_BUHGALTER)
        },

        isInWork() {
            return (this.orderstatuses_id == ov.ORDER_INWORK)
        },

        isFirstToWork() {
            // console.log(this.orderstatuses_id,this.prevstatus)
            var res = (this.orderstatuses_id == ov.ORDER_INWORK) && (![ov.ORDER_VERIFY_AFTER_NARRATOR, ov.ORDER_VERIFY_BEFORE_SOUNDENGINEER, ov.ORDER_VERIFY_AFTER_SOUNDENGINEER, ov.ORDER_COMPLETED, ov.ORDER_WAITING_PAYMENT_ADD_OPTIONS].includes(this.prevstatus))
            return res
        },

        isLinkInsideText() {
            return (this.comment_text.indexOf('http://') > -1) || (this.comment_text.indexOf('https://') > -1)
        },

        textWithFormattedLinks() {
            if (!this.comment_text) return
            var re = /(https?|ftp):\/\/\S+[^\s.,> )\];'\"!?]/;
            var subst = '<a href="$&" target="_blank">$&</a>';
            return this.comment_text.replace(re, subst);
        },

        replyText() {
            var reply_item = this.storeOrder.ordermessages.find(item => item.id == this.is_reply_for)
            if (reply_item) return reply_item.text
            return
        },

        isWithDeniedWords() {
            var d = false
            for (var word in this.appInfo.deniedwords) {
                if (
                    (this.comment_text.toLowerCase().indexOf(this.appInfo.deniedwords[word].toLowerCase()) >= 0)
                    || (this.comment_reply_text.toLowerCase().indexOf(this.appInfo.deniedwords[word].toLowerCase()) >= 0)
                ) {
                    d = true
                    break;
                }
            }
            return d
        },
    },

    data() {
        return {
            comment_id: this.id ? this.id : null,
            comment_text: this.text ? this.text : '',
            comment_files: this.files ? this.files : [],
            comment_reply_text: '',//this.reply_text ? this.reply_text : '',
            comment_reply_files: [],//this.reply_files ? this.reply_files : [],
            reply_opened: false,
            loading: false,
        };
    },

    methods: {

        openFileSelect() {
            var el = this.$refs[`file${this.comment_files.length - 1}`][0]
            el.click()
        },

        fileSelected() {
            var i = this.comment_files.length - 1
            this.comment_files[i].file_name = this.$refs[`file${i}`][0].files[0].name
            this.comment_files.push({ file_name: '' })
            // console.log(this.comment_files)
            this.$emit('files_change', this.comment_files.length - 1)
        },

        removeFile(index) {
            this.comment_files.splice(index, 1)
            // console.log(this.comment_files)
            this.$emit('files_change', this.comment_files.length - 1)
        },

        sendComment() {
            this.loading = true
            var formData = new FormData();
            formData.append('text', this.comment_text)
            formData.append('to', this.to)
            this.comment_files.forEach((el, i) => {
                if (typeof this.$refs[`file${i}`][0].files[0] !== 'undefined') formData.append("file[]", this.$refs[`file${i}`][0].files[0])
            })

            var role = this.$store.getters.loggedInUser.role
            this.$axios
                .post(`/${role}/orders/${this.order_id}/comments`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((res) => {
                    // console.log(res)
                    if (res.data.reload) {
                        location.reload()
                    } else {
                        this.comment_text = ''
                        this.comment_files = [{ file_name: '' }]
                        this.$emit('comment_added', res.data.comment)
                        this.loading = false
                        document.querySelector('[type="file"]').value = ''
                    }
                })
        },

        removeComment() {
            this.loading = true
            var role = this.$store.getters.loggedInUser.role
            this.$axios
                .delete(`/${role}/orders/${this.order_id}/comments/${this.comment_id}`)
                .then((res) => {
                    this.$emit('comment_removed', this.id)
                    this.loading = false
                })
        },


        openReply() {
            this.reply_opened = true
        },

        openReplyFileSelect() {
            // console.log(this.$refs.reply_file)
            // console.log(this.id)
            // console.log(document.getElementById(`reply_file_${this.id}_${this.comment_reply_files.length - 1}`))
            var el = this.$refs.reply_file[this.comment_reply_files.length - 1]
            el.click()
        },

        replyFileSelected() {
            var i = this.comment_reply_files.length - 1
            this.comment_reply_files[i].file_name = this.$refs.reply_file[i].files[0].name
            this.comment_reply_files.push({ file_name: '' })
        },

        removeReplyFile(index) {
            this.comment_reply_files.splice(index, 1)
        },

        sendReply() {
            this.loading = true
            var formData = new FormData();
            formData.append('text', this.comment_reply_text)
            this.comment_reply_files.forEach((el, i) => {
                if (typeof this.$refs.reply_file[i].files[0] !== 'undefined') {
                    formData.append("file[]", this.$refs.reply_file[i].files[0])
                }
            })
            formData.append('is_reply_for', this.comment_id)
            var role = this.$store.getters.loggedInUser.role
            this.$axios
                .post(`/${role}/orders/${this.order_id}/comments`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then((res) => {
                    this.reply_opened = false
                    this.comment_reply_text = ''
                    this.comment_reply_files = [{ file_name: '' }]
                    this.$emit('reply_added', res.data.comment)
                    this.loading = false
                })
        },

        addNeworderComment() {
            // console.log('addNeworderComment')
            // var formData = new FormData();
            // formData.append('text', this.comment_text)
            // this.comment_files.forEach((el, i) => {
            //     if (typeof this.$refs[`file${i}`][0].files[0] !== 'undefined') formData.append("file[]", this.$refs[`file${i}`][0].files[0])
            // })        
            // this.$store.commit('setOrderComment',formData)


            this.$emit('comment_added', {
                files: this.comment_files,
                text: this.comment_text,
            })
        },
    },

    mounted() {
        this.comment_reply_files.push({ file_name: '' })
        if (this.is_new || this.is_new_in_new_order) {
            this.comment_files.push({ file_name: '' })
        }

        this.$root.$on('update_order_message', (data = null) => {
            if (this.id == data.id) {
                this.comment_text = data.text
                this.comment_files = data.files
            }
        })
    },

    watch: {
        comment_text: function (val, oldVal) {
            this.$emit('change', val)
        },
    },

    beforeDestroy() {
        this.$root.$off('update_order_message')
    },

}
